import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import Avatar from './../../img/avatar-1-32.png';
import Loading from './../../img/loading.gif';
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css';
import moment from 'moment';
import 'moment-timezone';
import { CampaignPreview } from './CampaignPreview';



export class MessageList extends Component {

    constructor(props) {
        super(props);


        this.state = {
         openCampaignPreviewModal: false
        };
       
        this.toggleCampaignPreviewModal = this.toggleCampaignPreviewModal.bind(this);
    }

    componentDidUpdate() {
        const node = ReactDOM.findDOMNode(this)
        node.scrollTop = node.scrollHeight

        var element = document.getElementsByClassName("chat-dialog-area")[0];
        element.scrollTop = element.scrollHeight;
    }

    toggleCampaignPreviewModal() {
        this.setState({
            openCampaignPreviewModal: !this.state.openCampaignPreviewModal
        });
    }

    render() {
        
        let chatDlgAreaHeight = '600px';
        let windowInnerHeight = window.innerHeight;

        {
            this.props.isIframe && windowInnerHeight <= 600 ? chatDlgAreaHeight = '460px' :
            this.props.isIframe && windowInnerHeight <= 660 ? chatDlgAreaHeight = '500px' :
            this.props.isIframe && windowInnerHeight <= 720 ? chatDlgAreaHeight = '560px' :
            (!this.props.isIframe && windowInnerHeight < 890) ? chatDlgAreaHeight = '520px' :
            chatDlgAreaHeight = '600px'
        }

       /*alert("isiframe: " + this.props.isIframe + " - windowInnerHeight: " + windowInnerHeight + " - ChatDlgAreaHeight: " + chatDlgAreaHeight);*/         /*  TESTING ONLY  */

        let cnt = 0;

        return (
            <div id="chatListArea" className="rz-panel">
                <PerfectScrollbar className="chat-dialog-area msgList" style={{ height: chatDlgAreaHeight }}>
                    <div>
                        {this.props.messageList.length > 0 ?
                            this.props.messageList.map((message, index) => {

                                var serverTime = moment.tz(message.SentOn, "America/Los_Angeles");
                                var localTimezone = moment.tz.guess();
                                var localTime = serverTime.tz(localTimezone).format();

                                var chatContentClass;
                                var chatMessageTextClass;
                                var showLoading = false;

                                if (message.MessageDirection === 1) {
                                    chatContentClass = "justify-align-left";
                                    chatMessageTextClass = "chat-message gray";
                                } else if (message.MessageDirection === 2) {
                                    chatContentClass = "justify-align-right";
                                    chatMessageTextClass = "chat-message blue";
                                } else if (message.MessageDirection === 3) {
                                    chatContentClass = "justify-align-right";
                                    chatMessageTextClass = "chat-message green";
                                }

                                if (message.Loading == undefined || message.Loading == false)
                                    showLoading = false;

                                else
                                    showLoading = true;

                                cnt++;

                                return (
                                    < div className = "rz-card" key = { cnt }>
                                        <div className="chat-content">

                                            {/* new date only*/}
                                            <div className={"justify-align-center " + (message.IsNewSentOnDate ? "display-fl" : "display-no")}>
                                                <div className="badge badge-pill m-w-9">
                                                    {new Intl.DateTimeFormat('en-US', {
                                                        year: 'numeric',
                                                        month: '2-digit',
                                                        day: '2-digit'
                                                    }).format(new Date(localTime))}
                                                </div>
                                            </div>

                                            <div className={"chat chat-left text-align-center display-fl " + chatContentClass}>
                                                <div className="chat-body">
                                                    <div className={chatMessageTextClass}>
                                                        <div className="message-container">
                                                            <div className="pMsg">
                                                                {message.MessageDirection === 3 && <CampaignPreview isOpen={this.state.openCampaignPreviewModal} message={message} toggle={this.toggleCampaignPreviewModal} />}

                                                                {showLoading && <img alt="Loading" height="15" src={Loading} style={{ paddingRight: '10px' }} />}


                                                                {message.MessageDirection === 3 ? <a style={{ textDecorationLine: "underline" }} onClick={this.toggleCampaignPreviewModal}>View Campaign Message</a> : message.MessageBody.replace(/(<([^>]+)>)/ig, '')}
                                                            </div>
                                                        </div>
                                                        <span className="chat-time">
                                                            {message.FromName}&nbsp;|&nbsp;
                                                            {new Intl.DateTimeFormat('en-US', {
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            }).format(new Date(localTime))}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                        </div>
                                    </div>
                                );

                            })
                            : <div></div>}

                    </div>
                </PerfectScrollbar>
            </div>

        )
    }
}